import {
  SITE_URL,
  SITE_NAME,
  FAVICON_URL,
  getSeoForPath,
  getFaqForPath,
} from "./seo";
import type { FaqItem } from "./seo";

function faqSchema(items: FaqItem[]): object {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };
}

export function buildJsonLd(pathname: string): object[] {
  const seo = getSeoForPath(pathname);
  if (!seo) {
    return [];
  }

  const url = seo.canonicalPath
    ? `${SITE_URL}${seo.canonicalPath}`
    : SITE_URL;

  if (pathname === "/" || pathname === "") {
    const organization = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
      logo: FAVICON_URL,
    };

    const website = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE_NAME,
      url: SITE_URL,
    };

    const faq = faqSchema(getFaqForPath(pathname));

    return [organization, website, faq];
  }

  const article = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: seo.title,
    description: seo.description,
    image: seo.image ? [seo.image] : undefined,
    author: {
      "@type": "Organization",
      name: SITE_NAME,
    },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: {
        "@type": "ImageObject",
        url: FAVICON_URL,
      },
    },
    mainEntityOfPage: url,
    dateModified: "2026-08-24",
  };

  const breadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: SITE_URL,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: seo.title,
        item: url,
      },
    ],
  };

  const faq = faqSchema(getFaqForPath(pathname));

  return [article, breadcrumb, faq];
}